<template>
  <div class="bg-[#161816] text-white px-4 lg:px-32 mt-[15rem] mb-[97px]">
    <div>
      <h2 class="contact-title">Ignite your growth.</h2>
      <p class="text-[12px] lg:text-[24px] leading-[23px] lg:leading-[32px] font-[500] mb-12 lg:w-1/2 mt-[3rem]">Get in contact below. Together we can achieve your goals through innovative advertising solutions comprehensive data-driven insights, and explosive growth.</p>

      <form>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div>
            <input type="text" name="name" placeholder="Name" id="name" class="mt-1 block w-full border-b border-white bg-transparent text-white sm:text-sm">
          </div>
          <div>
            <input type="email" name="email" placeholder="E-mail address" id="email" class="mt-1 block w-full border-b border-white bg-transparent text-white sm:text-sm">
          </div>
          <div>
            <input type="text" name="company" id="company" placeholder="Company" class="mt-1 block w-full border-b border-white bg-transparent text-white sm:text-sm">
          </div>
        </div>

        <div class="mb-12">
          <label class="block text-white text-[12px] lg:text-[24px] font-[500] mb-4">I want to talk about</label>
          <div class="flex flex-wrap gap-[10px] lg:gap-[20px]">
            <button
              v-for="topic in topics"
              :key="topic"
              type="button"
              class="topic-button"
              :class="{ active: isTopicSelected(topic) }"
              @click="toggleTopic(topic)"
            >
              {{ topic }}
            </button>
          </div>
        </div>

        <div class="flex justify-end">
          <button type="submit" class="cta-light-button">
            <span class="text-[12px] lg:text-[24px]">Send</span>
            <svg class="hidden lg:block" width="35" height="19" viewBox="0 0 35 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 9.27533H33.0682" stroke="#52DA75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M25.8933 1L32.2859 7.39262C33.328 8.4347 33.328 10.1277 32.2859 11.1698L25.8933 17.5624" stroke="#52DA75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg class="lg:hidden" width="25" height="14" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 7.2771H24" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.854 1.3418L23.4389 5.92672C24.1863 6.67413 24.1863 7.8884 23.4389 8.63581L18.854 13.2207" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const selectedTopics = ref<string[]>([]);

const topics = [
  "Static Ads", "Motion Ads", "Creator Content Ads", "TikTok Creative", "Data", "Performance Marketing", "Pay Per Click", "Google Ads", "Organic Social", "Conversion Rate Optimisation", "Landing Pages"
];

const toggleTopic = (topic: string) => {
  const index = selectedTopics.value.indexOf(topic);
  if (index === -1) {
    selectedTopics.value.push(topic);
  } else {
    selectedTopics.value.splice(index, 1);
  }
};

const isTopicSelected = (topic: string) => {
  return selectedTopics.value.includes(topic);
};

</script>

<style scoped lang="scss">
input {
  font-size: 12px;
}
::placeholder {
  color: rgba(187, 180, 180, 1);
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12-18 */
  color: rgba(187, 180, 180, 1);
}
input:focus {
  outline: none;
}
.topic-button {
  position: relative;
  border: 1px solid #fff;
  border-radius: 9999px;
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: #fff;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  z-index: 1;
}

/* Remove the white border on hover */
.topic-button:hover {
  border-color: transparent;
}

.topic-button::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px; /* simulate the border width */
  background: linear-gradient(50.34deg, #52DA75 39.22%, #3CDFF8 145.92%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
  z-index: 0;
}

.topic-button:hover::before {
  opacity: 1;
}

.topic-button.active {
  background: linear-gradient(50.34deg, #52DA75 39.22%, #3CDFF8 145.92%);
  border-color: transparent;
  color: black;
}

.contact-title {
  padding: 5px 0;
  font-size: clamp(2.5rem, 5vw, 5rem);
  color: #ffffff;
  line-height: 30px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  font-family: 'Helvetica Now Display', sans-serif;
}
@media (max-width: 768px) {
  .contact-title {
    font-size: 30px;
  }
}
@media only screen and (min-width: 1024px) {
  .contact-title {
    line-height: 80px;
  }
  input {
    font-size: 24px;
  }
}
</style>
